import {getUserApiData} from "../../utils/UserUtils";
import {invokeApig} from "../../libs/awsLib";
import Paths from "../paths";
import {myID} from "../../libs/generateID";
import store from "../../store/store";
import {notify} from "reapop";
import i18n from "../../i18n";

export function editAnimal(animals, {FarmID, ClientID, LocalUserID} = {}) {
    const {_FarmID, _LocalUserID, _ClientID} = getUserApiData({FarmID, ClientID, LocalUserID});
    return invokeApig({
        ...Paths.editAnimal({farmID: _FarmID, clientID: _ClientID, localUserID: _LocalUserID}),
        body: animals
    })
}

export function editAnimalNotificationSuccess(response, {uniqueId = myID()} = {}) {
    store.dispatch(notify({
        id: uniqueId,
        title: i18n.t("logView.tableName.animals"),
        message: i18n.t("apiNotifications.editAnimalSuccess"),
        status: 'success',
        dismissible: true,
        dismissAfter: 5000
    }))
}

export function editAnimalNotificationFailure(response, {uniqueId = myID()} = {}) {
    store.dispatch(notify({
        id: uniqueId,
        title: i18n.t("logView.tableName.animals"),
        message: i18n.t("apiNotifications.editAnimalFailure"),
        status: 'error',
        dismissible: true,
        dismissAfter: 15000
    }))
}
